export const NetworkContextName = "Fiers Mainnet";
export const ACTIVE_NETWORK = 1001;

export const RPC_URL = "https://rpc1.fieroscan.com/"; //mainNet
export const default_RPC_URL = RPC_URL;
export const explorerURL = "https://fieroscan.com";

export const NetworkDetails = [
  {
    chainId: "0x1618",
    chainName: "QI Mainnet",
    nativeCurrency: {
      name: "QI",
      symbol: "QI",
      decimals: 18,
    },
    rpcUrls: [RPC_URL],
    blockExplorerUrls: [explorerURL],
  },
];
